<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.sourceCostNumber" clearable placeholder="编码" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.sourceCostName" clearable placeholder="名称" style="width:140px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="sourceCostNumber" label="编码" width="140" />
      <el-table-column prop="sourceCostName" label="名称" min-width="160" />
      <el-table-column prop="factoryName" label="工厂" width="140" />
      <el-table-column label="默认" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.defaultCost === '1' ? 'warning' : 'info'">{{ row.defaultCost === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.sourceCostId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.sourceCostId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.sourceCostId ? '修改源成本' : '新增源成本'" :visible.sync="visible" width="480px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="编码"><el-input v-model="form.sourceCostNumber" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="form.sourceCostName" /></el-form-item>
        <el-form-item label="工厂">
          <el-select v-model="form.factoryId" filterable clearable style="width:100%">
            <el-option v-for="f in factories" :key="f.factoryId" :label="f.factoryName" :value="f.factoryId" />
          </el-select>
        </el-form-item>
        <el-form-item label="默认"><el-switch v-model="form.defaultCost" active-value="1" inactive-value="0" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listSourceCost, getSourceCost, saveSourceCost, updateSourceCost, deleteSourceCost } from '../../api/sourceCost'
import { selectFactory } from '../../api/factory'

function emptyForm() {
  return {
    sourceCostId: '', sourceCostNumber: '', sourceCostName: '', factoryId: '', defaultCost: '0', active: '1'
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { sourceCostNumber: '', sourceCostName: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false,
      form: emptyForm(), factories: []
    }
  },
  created() {
    this.load()
    selectFactory().then(res => { this.factories = res.data || [] }).catch(() => {})
  },
  methods: {
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listSourceCost({
        currentPage: this.page, pageSize: this.pageSize,
        sourceCostNumber: this.query.sourceCostNumber, sourceCostName: this.query.sourceCostName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      getSourceCost(id).then(res => {
        const d = res.data || {}
        this.form = {
          sourceCostId: d.sourceCostId, sourceCostNumber: d.sourceCostNumber, sourceCostName: d.sourceCostName,
          factoryId: d.factoryId || '', defaultCost: d.defaultCost || '0', active: d.active || '1'
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.sourceCostNumber || !this.form.sourceCostName) { this.$message.warning('请填写编码和名称'); return }
      this.saving = true
      const req = this.form.sourceCostId ? updateSourceCost(this.form) : saveSourceCost(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteSourceCost([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
